import { useTranslator } from '@Localization';
import { ReactElement } from 'react';
import { IProjectActivity, IProjectActivityAddQuestion } from '../../projectDetailsActivities.models';

export const AddQuestionActivity = ({ values }: IProjectActivity<IProjectActivityAddQuestion>): ReactElement => {
  const { t } = useTranslator();
  return (
    <span>
      {t('activity_description_AddQuestion')}
      <b>{values.question}</b>.
    </span>
  );
};
